    import React                from 'react';
    import { useNavigate }      from 'react-router-dom';
    import ArrowBackIosIcon     from '@mui/icons-material/ArrowBackIos';
    import { 
        Container, 
        Box, 
        IconButton, 
        Typography
    } from '@mui/material';

    const ResiFormLayout = ({ color1, color2 , icon, title, children }) => {

    const navigate = useNavigate(); 

    const handleBackClick = () => {
        navigate(-1); 
    };

    return (
        <Container
        maxWidth="false"
        sx={{
            display: 'flex',
            backgroundColor: '#F8F8F8',
            flex: 1,
            width: '100vw',
            justifyContent: 'center',
            alignItems: 'stretch', 
            padding: 2,
        }}
        >
        <Box
            sx={{
            display: 'flex',
            backgroundColor: 'transparent',
            minHeight: '86%',
            width: '100%',
            flexDirection: 'row',
            }}
        >
            {/* Barra laterale */}
            <Box
            sx={{
                background: `linear-gradient(135deg, ${color1}, ${color2})`,
                width: '12%',
                minHeight: '86%', 
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                borderRadius: '10px 0px 0px 10px',
                pt: 5,
                gap: 4,
            }}
            >
            <Box
                sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'start',
                }}
            >
                <IconButton onClick={handleBackClick}>
                <ArrowBackIosIcon sx={{ color: 'white' }} />
                </IconButton>
            </Box>
            <Typography
                variant="h5"
                sx={{ color: '#fff', ml: 4, mr: 4, fontWeight: 'bold', display: {xs: 'none', lg: 'block'} }}
            >
                {title}
            </Typography>
            {icon && <Box sx={{ mr: 2 }}>{icon}</Box>}
            </Box>

            {/* Contenuto del form */}
            <Box
            sx={{
                width: '100%',
                minHeight: '86%',
                backgroundColor: '#ffffff',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1, 
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                borderRadius: '0px 10px 10px 0px',
                border: 'solid 1px #fda03d',
                borderLeft: 'none',
            }}
            >
            {children}
            </Box>
        </Box>
        </Container>
    );
    };

    export default ResiFormLayout;
